/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountDomains} from '../models/AccountDomains';
import type {ConnectionSettingsResponse} from '../models/ConnectionSettingsResponse';
import type {DomainValidationRequest} from '../models/DomainValidationRequest';
import type {DomainValidationResult} from '../models/DomainValidationResult';
import type {DownloadMetadataResponse} from '../models/DownloadMetadataResponse';
import type {DownloadSPMetadataRequest} from '../models/DownloadSPMetadataRequest';
import type {Error} from '../models/Error';
import type {FetchSamlMetadataRequest} from '../models/FetchSamlMetadataRequest';
import type {FetchSamlMetadataResponse} from '../models/FetchSamlMetadataResponse';
import type {InlineResponse200} from '../models/InlineResponse200';
import type {SertificateValidatorRequest} from '../models/SertificateValidatorRequest';

export interface DeleteConnection$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteConnectionRequest = createAction<PayloadData<void>>('SSO__DELETE_CONNECTION__REQUEST');
export const deleteConnectionSuccess = createAction<PayloadData<void>>('SSO__DELETE_CONNECTION__SUCCESS');
export const deleteConnectionFailure = createAction<PayloadData<Error, void, true>>('SSO__DELETE_CONNECTION__FAILURE');

export const deleteConnectionActions = [
    deleteConnectionRequest,
    deleteConnectionSuccess,
    deleteConnectionFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteConnection = (config?: DeleteConnection$Config) => {
    return {
        CALL_API: {
            types: deleteConnectionActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/sso/connection`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface DownloadSpMetadata$Request {
    downloadSPMetadataRequest: DownloadSPMetadataRequest;
}

export interface DownloadSpMetadata$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const downloadSpMetadataRequest = createAction<PayloadData<void, DownloadSpMetadata$Request>>('SSO__DOWNLOAD_SP_METADATA__REQUEST');
export const downloadSpMetadataSuccess = createAction<PayloadData<DownloadMetadataResponse, DownloadSpMetadata$Request>>('SSO__DOWNLOAD_SP_METADATA__SUCCESS');
export const downloadSpMetadataFailure = createAction<PayloadData<Error, DownloadSpMetadata$Request, true>>('SSO__DOWNLOAD_SP_METADATA__FAILURE');

export const downloadSpMetadataActions = [
    downloadSpMetadataRequest,
    downloadSpMetadataSuccess,
    downloadSpMetadataFailure
] as const;

/**
 * @param {DownloadSPMetadataRequest} meta.downloadSPMetadataRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const downloadSpMetadata = (meta: DownloadSpMetadata$Request, config?: DownloadSpMetadata$Config) => {
    return {
        CALL_API: {
            types: downloadSpMetadataActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/sso/download-metadata`,
            TRANSPORT_REQUEST_BODY: meta.downloadSPMetadataRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface FetchAccountDomains$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const fetchAccountDomainsRequest = createAction<PayloadData<void>>('SSO__FETCH_ACCOUNT_DOMAINS__REQUEST');
export const fetchAccountDomainsSuccess = createAction<PayloadData<AccountDomains>>('SSO__FETCH_ACCOUNT_DOMAINS__SUCCESS');
export const fetchAccountDomainsFailure = createAction<PayloadData<Error, void, true>>('SSO__FETCH_ACCOUNT_DOMAINS__FAILURE');

export const fetchAccountDomainsActions = [
    fetchAccountDomainsRequest,
    fetchAccountDomainsSuccess,
    fetchAccountDomainsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const fetchAccountDomains = (config?: FetchAccountDomains$Config) => {
    return {
        CALL_API: {
            types: fetchAccountDomainsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso/account-domains`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface FetchSamlMetadata$Request {
    fetchSamlMetadataRequest: FetchSamlMetadataRequest;
}

export interface FetchSamlMetadata$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const fetchSamlMetadataRequest = createAction<PayloadData<void, FetchSamlMetadata$Request>>('SSO__FETCH_SAML_METADATA__REQUEST');
export const fetchSamlMetadataSuccess = createAction<PayloadData<FetchSamlMetadataResponse, FetchSamlMetadata$Request>>('SSO__FETCH_SAML_METADATA__SUCCESS');
export const fetchSamlMetadataFailure = createAction<PayloadData<Error, FetchSamlMetadata$Request, true>>('SSO__FETCH_SAML_METADATA__FAILURE');

export const fetchSamlMetadataActions = [
    fetchSamlMetadataRequest,
    fetchSamlMetadataSuccess,
    fetchSamlMetadataFailure
] as const;

/**
 * @param {FetchSamlMetadataRequest} meta.fetchSamlMetadataRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const fetchSamlMetadata = (meta: FetchSamlMetadata$Request, config?: FetchSamlMetadata$Config) => {
    return {
        CALL_API: {
            types: fetchSamlMetadataActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/sso/fetch-metadata`,
            TRANSPORT_REQUEST_BODY: meta.fetchSamlMetadataRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GenerateSsoLoginLink$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const generateSsoLoginLinkRequest = createAction<PayloadData<void>>('SSO__GENERATE_SSO_LOGIN_LINK__REQUEST');
export const generateSsoLoginLinkSuccess = createAction<PayloadData<InlineResponse200>>('SSO__GENERATE_SSO_LOGIN_LINK__SUCCESS');
export const generateSsoLoginLinkFailure = createAction<PayloadData<Error, void, true>>('SSO__GENERATE_SSO_LOGIN_LINK__FAILURE');

export const generateSsoLoginLinkActions = [
    generateSsoLoginLinkRequest,
    generateSsoLoginLinkSuccess,
    generateSsoLoginLinkFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const generateSsoLoginLink = (config?: GenerateSsoLoginLink$Config) => {
    return {
        CALL_API: {
            types: generateSsoLoginLinkActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso/login-link`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetConnection$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getConnectionRequest = createAction<PayloadData<void>>('SSO__GET_CONNECTION__REQUEST');
export const getConnectionSuccess = createAction<PayloadData<ConnectionSettingsResponse>>('SSO__GET_CONNECTION__SUCCESS');
export const getConnectionFailure = createAction<PayloadData<Error, void, true>>('SSO__GET_CONNECTION__FAILURE');

export const getConnectionActions = [
    getConnectionRequest,
    getConnectionSuccess,
    getConnectionFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getConnection = (config?: GetConnection$Config) => {
    return {
        CALL_API: {
            types: getConnectionActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso/connection`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface ValidateDomains$Request {
    domainValidationRequest: DomainValidationRequest;
}

export interface ValidateDomains$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const validateDomainsRequest = createAction<PayloadData<void, ValidateDomains$Request>>('SSO__VALIDATE_DOMAINS__REQUEST');
export const validateDomainsSuccess = createAction<PayloadData<DomainValidationResult, ValidateDomains$Request>>('SSO__VALIDATE_DOMAINS__SUCCESS');
export const validateDomainsFailure = createAction<PayloadData<Error, ValidateDomains$Request, true>>('SSO__VALIDATE_DOMAINS__FAILURE');

export const validateDomainsActions = [
    validateDomainsRequest,
    validateDomainsSuccess,
    validateDomainsFailure
] as const;

/**
 * @param {DomainValidationRequest} meta.domainValidationRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const validateDomains = (meta: ValidateDomains$Request, config?: ValidateDomains$Config) => {
    return {
        CALL_API: {
            types: validateDomainsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/sso/domains/validation`,
            TRANSPORT_REQUEST_BODY: meta.domainValidationRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface ValidateSamlCertificate$Request {
    sertificateValidatorRequest: SertificateValidatorRequest;
}

export interface ValidateSamlCertificate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const validateSamlCertificateRequest = createAction<PayloadData<void, ValidateSamlCertificate$Request>>('SSO__VALIDATE_SAML_CERTIFICATE__REQUEST');
export const validateSamlCertificateSuccess = createAction<PayloadData<void, ValidateSamlCertificate$Request>>('SSO__VALIDATE_SAML_CERTIFICATE__SUCCESS');
export const validateSamlCertificateFailure = createAction<PayloadData<Error, ValidateSamlCertificate$Request, true>>('SSO__VALIDATE_SAML_CERTIFICATE__FAILURE');

export const validateSamlCertificateActions = [
    validateSamlCertificateRequest,
    validateSamlCertificateSuccess,
    validateSamlCertificateFailure
] as const;

/**
 * @param {SertificateValidatorRequest} meta.sertificateValidatorRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const validateSamlCertificate = (meta: ValidateSamlCertificate$Request, config?: ValidateSamlCertificate$Config) => {
    return {
        CALL_API: {
            types: validateSamlCertificateActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/sso/sertificate-validator`,
            TRANSPORT_REQUEST_BODY: meta.sertificateValidatorRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

